import { useAuth } from "../contexts/AuthProvider";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import { FEATURE_FLAGS } from "../contexts/FeatureFlagsProvider";
import { useFeatureFlag } from "./useOpenFeatureFlag";

/**
 * What the signed-in user may do with facility announcements (DAT-977) in the chosen department — the frontend
 * mirror of the backend's `require_facility_wide_messages` / `require_facility_announcement_sender`, which must
 * agree with it or the UI offers what the API refuses.
 *
 * - `canView`: the department has the feature (`facility_wide_messages`), so the Announcements list shows.
 * - `canSend`: the feature, and the "Send facility-wide messages" permission here (support always holds it), so
 *   the composer offers other departments and the whole building.
 */
export const useFacilityWideMessages = (): { canView: boolean; canSend: boolean } => {
	const enabled = useFeatureFlag(FEATURE_FLAGS.FacilityWideMessages);
	const { userInfo } = useAuth();
	const { chosenDepartment } = useChosenDepartment();
	const currentDept = userInfo?.departments?.find((dept) => dept.department_id === chosenDepartment.department_id);
	const holdsPermission = Boolean(userInfo && (userInfo.support || currentDept?.send_facility_messages === true));
	return { canView: enabled, canSend: enabled && holdsPermission };
};
